import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { Container, Wrapper } from './styles';
import noTestTemp from '../../images/noTestTemp.jpg';
import { TEMPLATE_NOT_AVAILABLE_IN_ENVIRONMENT_PAGE } from './translationValues';

const NAMESPACES = ['TEMPLATE_NOT_AVAILABLE_IN_ENVIRONMENT_PAGE'];
class NoSuchEnvironment extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { t } = this.props;
    return (
      <Container shortMessage={this.props.shortMessage}>
        <Wrapper>
          <img src={noTestTemp} />
          <div className="text">
            {this.props.text === undefined ? this.props.testVersion
              ? t(
                  TEMPLATE_NOT_AVAILABLE_IN_ENVIRONMENT_PAGE.NOT_YET_SEND_FOR_TESTING_TEXT.key,
                  TEMPLATE_NOT_AVAILABLE_IN_ENVIRONMENT_PAGE.NOT_YET_SEND_FOR_TESTING_TEXT.value,
                )
              : t(
                  TEMPLATE_NOT_AVAILABLE_IN_ENVIRONMENT_PAGE.NOT_YET_SEND_TO_PUBLISH_TEXT.key,
                  TEMPLATE_NOT_AVAILABLE_IN_ENVIRONMENT_PAGE.NOT_YET_SEND_TO_PUBLISH_TEXT.value,
                ) : this.props.text}
          </div>
        </Wrapper>
      </Container>
    );
  }
}

export default withTranslation(NAMESPACES)(NoSuchEnvironment);
